// extracted by mini-css-extract-plugin
module.exports = {"root":"📦Blockquote__root--18M9B"};